import React from 'react';
import cx from 'classnames';
import Base from './Base';


const PrimaryButton = ({className, ...props}) => <Base {...props} className={cx("btn--primary", className)} />;

export default PrimaryButton;
